import {Component, Input} from '@angular/core';
import { FaqMailSubjectPipe } from '../../../pipes/faq/faqMailSubject.pipe';
import { FaqPageDetailDto } from '../../../domain/faq/faqNodeDetailDto';
import {SupportContactComponent} from '../../supportChoice/supportContact/supportContact.component';
import {ModalControllerService} from '../../../services/common/modalController.service';

@Component({
    selector: 'faq-contact[faqPage]',
    templateUrl: './faqContact.component.html',
    styleUrls: ['./faqContact.component.scss']
})
export class FaqContactComponent {

    @Input() faqPage: FaqPageDetailDto;

    constructor(private readonly modalControllerService: ModalControllerService,
        private readonly faqMailSubjectPipe: FaqMailSubjectPipe,
    ) {
    }

    openContactModal(): void {
        if (this.faqPage.contact) {
            this.modalControllerService.display({
                component: SupportContactComponent,
                componentProps: {
                    supportContact: this.faqPage.contact,
                    supportContactContext: {
                        mailSubject: this.faqMailSubjectPipe.transform(this.faqPage)
                    }
                },
                backdropDismiss: false
            }).subscribe();
        }
    }
}
